import React from 'react';

const ErrorPage = () => <>Ups... This page does not exist.</>;

export default ErrorPage;
